import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import ApplicationCard from './components/ApplicationCard';
import FilterBar from './components/FilterBar';
import StatsOverview from './components/StatsOverview';
import UpcomingInterviews from './components/UpcomingInterviews';
import CommunicationPanel from './components/CommunicationPanel';
import WithdrawConfirmation from './components/WithdrawConfirmation';

const ApplicationTracking = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all-applications');
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    status: 'all',
    sort: 'date-desc',
    jobType: 'all',
    timeRange: 'all'
  });
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showCommunications, setShowCommunications] = useState(false);
  const [showWithdrawConfirm, setShowWithdrawConfirm] = useState(false);
  const [applicationToWithdraw, setApplicationToWithdraw] = useState(null);

  const mockApplications = [
  {
    id: 1,
    jobId: 'job-001',
    jobTitle: 'Senior React Developer',
    companyName: 'Tech Innovations Pvt Ltd',
    companyLogo: "https://images.unsplash.com/photo-1715950227433-4cd241cc50b2",
    companyLogoAlt: 'Modern tech company office building with glass facade and blue sky background',
    location: 'Bangalore, Karnataka',
    experience: '5-8 years',
    salary: '₹15-25 LPA',
    status: 'interview-scheduled',
    appliedDate: '2025-11-15T10:30:00',
    lastUpdated: '2025-11-25T14:20:00',
    interviewDate: '2025-11-30T10:00:00',
    interviewTime: '10:00 AM IST',
    interviewType: 'Technical Round - Video Call',
    communicationCount: 3,
    timeline: [
    {
      icon: 'Send',
      title: 'Application Submitted',
      description: 'Your application has been received and is under review',
      date: '2025-11-15T10:30:00'
    },
    {
      icon: 'Eye',
      title: 'Application Reviewed',
      description: 'Your profile has been reviewed by the hiring team',
      date: '2025-11-18T15:45:00'
    },
    {
      icon: 'Star',
      title: 'Shortlisted',
      description: 'Congratulations! You have been shortlisted for the next round',
      date: '2025-11-22T11:20:00'
    },
    {
      icon: 'Calendar',
      title: 'Interview Scheduled',
      description: 'Technical interview scheduled with the development team',
      date: '2025-11-25T14:20:00'
    }],

    recruiterNotes: 'Your profile matches our requirements perfectly. Please prepare for technical questions on React, Redux, and system design.'
  },
  {
    id: 2,
    jobId: 'job-002',
    jobTitle: 'Full Stack Developer',
    companyName: 'Digital Solutions India',
    companyLogo: "https://images.unsplash.com/photo-1649621902418-eaa73f09b341",
    companyLogoAlt: 'Corporate office building with modern architecture and reflective glass windows',
    location: 'Mumbai, Maharashtra',
    experience: '3-5 years',
    salary: '₹12-18 LPA',
    status: 'under-review',
    appliedDate: '2025-11-20T09:15:00',
    lastUpdated: '2025-11-23T16:30:00',
    communicationCount: 1,
    timeline: [
    {
      icon: 'Send',
      title: 'Application Submitted',
      description: 'Your application has been successfully submitted',
      date: '2025-11-20T09:15:00'
    },
    {
      icon: 'Eye',
      title: 'Under Review',
      description: 'Your application is currently being reviewed by our team',
      date: '2025-11-23T16:30:00'
    }]

  },
  {
    id: 3,
    jobId: 'job-003',
    jobTitle: 'Frontend Developer',
    companyName: 'StartupHub Technologies',
    companyLogo: "https://images.unsplash.com/photo-1556761175-4b46a572b786",
    companyLogoAlt: 'Modern startup office space with open floor plan and collaborative workstations',
    location: 'Pune, Maharashtra',
    experience: '2-4 years',
    salary: '₹8-14 LPA',
    status: 'shortlisted',
    appliedDate: '2025-11-18T14:45:00',
    lastUpdated: '2025-11-24T10:15:00',
    communicationCount: 2,
    timeline: [
    {
      icon: 'Send',
      title: 'Application Submitted',
      description: 'Application received successfully',
      date: '2025-11-18T14:45:00'
    },
    {
      icon: 'Eye',
      title: 'Application Reviewed',
      description: 'Profile reviewed by hiring manager',
      date: '2025-11-21T11:30:00'
    },
    {
      icon: 'Star',
      title: 'Shortlisted',
      description: 'You have been shortlisted for further evaluation',
      date: '2025-11-24T10:15:00'
    }],

    recruiterNotes: 'Impressive portfolio! We will contact you soon for the next steps.'
  },
  {
    id: 4,
    jobId: 'job-004',
    jobTitle: 'React Native Developer',
    companyName: 'Mobile First Solutions',
    companyLogo: "https://images.unsplash.com/photo-1568226189232-d4baf2b86437",
    companyLogoAlt: 'Contemporary tech office with large windows and natural lighting',
    location: 'Hyderabad, Telangana',
    experience: '4-6 years',
    salary: '₹14-20 LPA',
    status: 'submitted',
    appliedDate: '2025-11-22T11:20:00',
    communicationCount: 0,
    timeline: [
    {
      icon: 'Send',
      title: 'Application Submitted',
      description: 'Your application has been submitted successfully',
      date: '2025-11-22T11:20:00'
    }]

  },
  {
    id: 5,
    jobId: 'job-005',
    jobTitle: 'UI/UX Developer',
    companyName: 'Design Studio Pro',
    companyLogo: "https://images.unsplash.com/photo-1610018576043-968b9b6a816e",
    companyLogoAlt: 'Creative design studio with modern furniture and artistic workspace',
    location: 'Delhi NCR',
    experience: '3-5 years',
    salary: '₹10-16 LPA',
    status: 'rejected',
    appliedDate: '2025-11-10T15:30:00',
    lastUpdated: '2025-11-20T09:45:00',
    communicationCount: 2,
    timeline: [
    {
      icon: 'Send',
      title: 'Application Submitted',
      description: 'Application submitted for review',
      date: '2025-11-10T15:30:00'
    },
    {
      icon: 'Eye',
      title: 'Application Reviewed',
      description: 'Your profile was reviewed',
      date: '2025-11-15T14:20:00'
    },
    {
      icon: 'XCircle',
      title: 'Application Not Selected',
      description: 'Thank you for your interest. We have decided to move forward with other candidates.',
      date: '2025-11-20T09:45:00'
    }],

    recruiterNotes: 'We appreciate your application. While your skills are impressive, we found candidates with more specific experience in our tech stack.'
  },
  {
    id: 6,
    jobId: 'job-006',
    jobTitle: 'Senior JavaScript Developer',
    companyName: 'Enterprise Solutions Ltd',
    companyLogo: "https://images.unsplash.com/photo-1663667014030-3b32f5ee1088",
    companyLogoAlt: 'Large corporate headquarters building with modern glass architecture',
    location: 'Chennai, Tamil Nadu',
    experience: '6-9 years',
    salary: '₹18-28 LPA',
    status: 'offer-received',
    appliedDate: '2025-11-05T10:00:00',
    lastUpdated: '2025-11-26T16:00:00',
    communicationCount: 5,
    timeline: [
    {
      icon: 'Send',
      title: 'Application Submitted',
      description: 'Application received',
      date: '2025-11-05T10:00:00'
    },
    {
      icon: 'Eye',
      title: 'Application Reviewed',
      description: 'Profile reviewed successfully',
      date: '2025-11-08T11:30:00'
    },
    {
      icon: 'Star',
      title: 'Shortlisted',
      description: 'Selected for interview rounds',
      date: '2025-11-12T14:20:00'
    },
    {
      icon: 'Calendar',
      title: 'Interviews Completed',
      description: 'Successfully completed all interview rounds',
      date: '2025-11-20T15:45:00'
    },
    {
      icon: 'CheckCircle',
      title: 'Offer Extended',
      description: 'Congratulations! We are pleased to extend an offer of employment',
      date: '2025-11-26T16:00:00'
    }],

    recruiterNotes: 'Excellent performance in all rounds! Please review the offer letter and respond within 7 days.'
  }];


  const mockUpcomingInterviews = [
  {
    id: 1,
    jobId: 'job-001',
    jobTitle: 'Senior React Developer',
    companyName: 'Tech Innovations Pvt Ltd',
    companyLogo: "https://images.unsplash.com/photo-1715950227433-4cd241cc50b2",
    companyLogoAlt: 'Modern tech company office building with glass facade and blue sky background',
    date: '2025-11-30T10:00:00',
    time: '10:00 AM IST',
    type: 'Technical Round - Video Call',
    interviewer: 'Rajesh Kumar (Tech Lead)',
    meetingLink: 'https://meet.google.com/abc-defg-hij',
    notes: 'Please ensure you have a stable internet connection and a quiet environment. The interview will focus on React, Redux, and system design concepts.'
  },
  {
    id: 2,
    jobId: 'job-007',
    jobTitle: 'Backend Developer',
    companyName: 'Cloud Services India',
    companyLogo: "https://images.unsplash.com/photo-1556761175-4b46a572b786",
    companyLogoAlt: 'Modern startup office space with open floor plan and collaborative workstations',
    date: '2025-12-02T14:00:00',
    time: '02:00 PM IST',
    type: 'HR Round - Phone Call',
    interviewer: 'Priya Sharma (HR Manager)',
    notes: 'This will be a preliminary discussion about your background, expectations, and company culture fit.'
  }];


  const mockCommunications = [
  {
    id: 1,
    type: 'email',
    sender: 'Tech Innovations Pvt Ltd',
    subject: 'Interview Scheduled - Senior React Developer',
    preview: 'We are pleased to inform you that your interview has been scheduled for November 30th...',
    fullMessage: `Dear Candidate,\n\nWe are pleased to inform you that your interview has been scheduled for November 30th, 2025 at 10:00 AM IST.\n\nInterview Details:\n- Position: Senior React Developer\n- Type: Technical Round - Video Call\n- Interviewer: Rajesh Kumar (Tech Lead)\n- Duration: 60 minutes\n\nPlease join the meeting using the link provided in your application tracking dashboard.\n\nBest regards,\nTech Innovations Recruitment Team`,
    date: '2025-11-25T14:20:00',
    isRead: false,
    attachments: [
    { name: 'Interview_Guidelines.pdf', size: '245 KB' }]

  },
  {
    id: 2,
    type: 'notification',
    sender: 'JobPortal India',
    subject: 'Application Status Updated',
    preview: 'Your application for Senior React Developer has been updated to Interview Scheduled...',
    fullMessage: 'Your application for Senior React Developer at Tech Innovations Pvt Ltd has been updated to Interview Scheduled. Please check your dashboard for more details.',
    date: '2025-11-25T14:25:00',
    isRead: false
  },
  {
    id: 3,
    type: 'email',
    sender: 'Digital Solutions India',
    subject: 'Application Received - Full Stack Developer',
    preview: 'Thank you for applying to the Full Stack Developer position...',
    fullMessage: `Dear Candidate,\n\nThank you for applying to the Full Stack Developer position at Digital Solutions India.\n\nWe have received your application and our team is currently reviewing it. We will get back to you within 5-7 business days.\n\nBest regards,\nDigital Solutions HR Team`,
    date: '2025-11-20T09:20:00',
    isRead: true
  }];


  const mockStats = {
    total: 6,
    underReview: 1,
    interviews: 2,
    offers: 1,
    responseRate: 67,
    avgResponseTime: 5
  };

  const [filteredApplications, setFilteredApplications] = useState(mockApplications);

  useEffect(() => {
    let result = [...mockApplications];

    if (searchQuery) {
      result = result?.filter((app) =>
      app?.jobTitle?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      app?.companyName?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      app?.location?.toLowerCase()?.includes(searchQuery?.toLowerCase())
      );
    }

    if (filters?.status !== 'all') {
      result = result?.filter((app) => app?.status === filters?.status);
    }

    if (filters?.timeRange !== 'all') {
      const now = new Date();
      result = result?.filter((app) => {
        const appDate = new Date(app.appliedDate);
        const diffDays = Math.ceil((now - appDate) / (1000 * 60 * 60 * 24));

        switch (filters?.timeRange) {
          case 'today':
            return diffDays === 0;
          case 'week':
            return diffDays <= 7;
          case 'month':
            return diffDays <= 30;
          case 'quarter':
            return diffDays <= 90;
          default:
            return true;
        }
      });
    }

    switch (filters?.sort) {
      case 'date-desc':
        result?.sort((a, b) => new Date(b.appliedDate) - new Date(a.appliedDate));
        break;
      case 'date-asc':
        result?.sort((a, b) => new Date(a.appliedDate) - new Date(b.appliedDate));
        break;
      case 'company-asc':
        result?.sort((a, b) => a?.companyName?.localeCompare(b?.companyName));
        break;
      case 'company-desc':
        result?.sort((a, b) => b?.companyName?.localeCompare(a?.companyName));
        break;
      case 'status':
        const statusOrder = ['interview-scheduled', 'shortlisted', 'under-review', 'submitted', 'offer-received', 'rejected'];
        result?.sort((a, b) => statusOrder?.indexOf(a?.status) - statusOrder?.indexOf(b?.status));
        break;
      default:
        break;
    }

    setFilteredApplications(result);
  }, [searchQuery, filters]);

  const handleFilterChange = (key, value) => {
    if (key === 'reset') {
      setFilters({
        status: 'all',
        sort: 'date-desc',
        jobType: 'all',
        timeRange: 'all'
      });
    } else {
      setFilters((prev) => ({ ...prev, [key]: value }));
    }
  };

  const handleWithdraw = (application) => {
    setApplicationToWithdraw(application);
    setShowWithdrawConfirm(true);
  };

  const confirmWithdraw = (application) => {
    console.log('Withdrawing application:', application?.id);
    setShowWithdrawConfirm(false);
    setApplicationToWithdraw(null);
  };

  const handleViewDetails = (application) => {
    setSelectedApplication(application);
    setShowCommunications(true);
  };

  const tabs = [
  { id: 'all-applications', label: 'All Applications', icon: 'FileText', count: mockApplications?.length },
  { id: 'interviews', label: 'Upcoming Interviews', icon: 'Calendar', count: mockUpcomingInterviews?.length },
  { id: 'communications', label: 'Communications', icon: 'MessageSquare', count: mockCommunications?.filter((c) => !c?.isRead)?.length }];


  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20 pb-12 px-4 lg:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
              <div>
                <h1 className="text-3xl font-bold text-foreground mb-2">Application Tracking</h1>
                <p className="text-muted-foreground">Monitor your job applications and manage your job search pipeline</p>
              </div>
              <Button
                variant="default"
                iconName="Search"
                iconPosition="left"
                onClick={() => navigate('/job-listings')}>

                Browse Jobs
              </Button>
            </div>

            <StatsOverview stats={mockStats} />
          </div>

          <div className="bg-card border border-border rounded-lg mb-6">
            <div className="border-b border-border overflow-x-auto">
              <div className="flex">
                {tabs?.map((tab) =>
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-smooth whitespace-nowrap ${
                  activeTab === tab?.id ?
                  'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`
                  }>

                    <Icon name={tab?.icon} size={18} />
                    <span>{tab?.label}</span>
                    {tab?.count > 0 &&
                  <span className={`inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-xs font-medium ${
                  activeTab === tab?.id ?
                  'bg-primary text-primary-foreground' :
                  'bg-muted text-muted-foreground'}`
                  }>
                        {tab?.count}
                      </span>
                  }
                  </button>
                )}
              </div>
            </div>
          </div>

          {activeTab === 'all-applications' &&
          <div className="space-y-6">
              <FilterBar
              onFilterChange={handleFilterChange}
              onSearchChange={setSearchQuery}
              activeFilters={filters} />


              {filteredApplications?.length === 0 ?
            <div className="bg-card border border-border rounded-lg p-12 text-center">
                  <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="Search" size={40} className="text-muted-foreground" />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-2">No Applications Found</h3>
                  <p className="text-muted-foreground mb-6">
                    {searchQuery || filters?.status !== 'all' || filters?.timeRange !== 'all' ? 'Try adjusting your filters or search query' : 'Start applying to jobs to see them here'}
                  </p>
                  <Button
                variant="default"
                iconName="Search"
                iconPosition="left"
                onClick={() => navigate('/job-listings')}>

                    Browse Jobs
                  </Button>
                </div> :

            <div className="space-y-4">
                  {filteredApplications?.map((application) =>
              <ApplicationCard
                key={application?.id}
                application={application}
                onWithdraw={handleWithdraw}
                onViewDetails={handleViewDetails} />

              )}
                </div>
            }
            </div>
          }

          {activeTab === 'interviews' &&
          <UpcomingInterviews interviews={mockUpcomingInterviews} />
          }

          {activeTab === 'communications' &&
          <div className="bg-card border border-border rounded-lg p-6">
              <div className="space-y-4">
                {mockCommunications?.map((comm) =>
              <div
                key={comm?.id}
                className={`border border-border rounded-lg p-4 cursor-pointer transition-smooth ${
                comm?.isRead ? 'bg-card' : 'bg-blue-50 dark:bg-blue-900/20'} hover:shadow-md`
                }
                onClick={() => {
                  setSelectedApplication({ communications: mockCommunications });
                  setShowCommunications(true);
                }}>

                    <div className="flex items-start gap-3">
                      <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  comm?.isRead ? 'bg-muted' : 'bg-primary/10'}`
                  }>
                        <Icon
                      name={comm?.type === 'email' ? 'Mail' : 'Bell'}
                      size={20}
                      className={comm?.isRead ? 'text-muted-foreground' : 'text-primary'} />

                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-2 mb-2">
                          <h3 className={`text-sm font-semibold ${
                      comm?.isRead ? 'text-foreground' : 'text-primary'}`
                      }>
                            {comm?.subject}
                          </h3>
                          {!comm?.isRead &&
                      <span className="inline-flex items-center px-2 py-1 bg-primary text-primary-foreground rounded-full text-xs font-medium">
                              New
                            </span>
                      }
                        </div>
                        <p className="text-sm text-muted-foreground mb-2">{comm?.sender}</p>
                        <p className="text-sm text-foreground line-clamp-2">{comm?.preview}</p>
                      </div>
                    </div>
                  </div>
              )}
              </div>
            </div>
          }
        </div>
      </main>
      {showCommunications &&
      <CommunicationPanel
        communications={mockCommunications}
        onClose={() => {
          setShowCommunications(false);
          setSelectedApplication(null);
        }} />

      }
      {showWithdrawConfirm && applicationToWithdraw &&
      <WithdrawConfirmation
        application={applicationToWithdraw}
        onConfirm={confirmWithdraw}
        onCancel={() => {
          setShowWithdrawConfirm(false);
          setApplicationToWithdraw(null);
        }} />

      }
    </div>);

};

export default ApplicationTracking;